import { useMemo } from 'react'
import { EmptyState, formatDateTime } from '@/kit/ui'
import { useHubStore } from '@/store/hubStore'
import type { Lender } from '@/types'

/** Tab 4 · History (F1-6): every change of this lender, newest first. */
export function HistoryTab({ lender }: { lender: Lender }) {
  const history = useHubStore((s) => s.history)
  const rows = useMemo(() => history.filter((h) => h.lenderSlug === lender.slug), [history, lender.slug])
  if (!rows.length) return <EmptyState title="No changes yet" description="Every edit, switch and version change of this lender lands here with who did it." />
  return (
    <div className="card-flush overflow-x-auto">
      <table className="table">
        <thead><tr><th>When</th><th>Who</th><th>Where</th><th>What</th></tr></thead>
        <tbody>
          {rows.map((h) => (
            <tr key={h.id}>
              <td className="mono whitespace-nowrap">{formatDateTime(h.at)}</td>
              <td>{h.who}</td>
              <td>{h.where}</td>
              <td>{h.what}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
